import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

// import svg from '../../../../img/symbol.svg'
function PersonalInformation(props) {
  const dateRef = useRef();
  //const [Options, setOptions] = useState({ show: false, value: '' })
  const bloodType = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
  const Branch = ["Head Branch", "Pal Branch"];
  const {
    FirstName,
    LastName,
    Description,
    Gender,
    MobileNo,
    Email,
    Address,
    BirthDate,
    error,
    userImage,
    Age,
    ImageFile,
    activeTab,
    isLoading,
    Options,
    branchOption,
  } = props.data;
  const handleChange = (e, Name) => {
    props.handleChange(e, Name);
  };

  function ValidateMobile(number) {
    number = number.trim();
    var validFormat = /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/;
    if (!validFormat.test(number)) {
      return false;
    }
    var digitCount = number.replace(/\D/g, "").length;
    if (digitCount >= 7 && digitCount <= 15) {
      return true;
    } else {
      return false;
    }
  }

  const onHandleTelephoneChange = (e, name) => {
    let telephone = e.target.value;
    if (telephone === "" || /^[0-9+\-() .]*$/.test(telephone)) {
      props.handleState([name], telephone);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // props.handleSubmit()
    // alert("dsfkjfdsfj")
    if (
      FirstName == "" ||
      LastName == "" ||
      Gender == "" ||
      MobileNo == "" ||
      Address == "" ||
      BirthDate == ""
    ) {
      props.handleState("error", true);
    } else if (
      !Email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      props.handleState("error", true);
    } else if (!ValidateMobile(MobileNo)) {
      props.handleState("error", true);
    } else {
      props.handleState("isLoading", true);
      var data = {
        address: Address,
        birthdate: BirthDate,
        age: Age,
        description: Description,
        profile_image: ImageFile,
        email: Email,
        first_name: FirstName,
        gender: "Female",
        last_name: LastName,
        mobile: MobileNo,
      };

      props.handleSubmit(data);
    }
  };
  return (
    <div className={`main ${activeTab == 1 ? "active" : ""}`}>
      <div className="text">
        <h3>Your Personal Information</h3>
        <p>
          Enter your personal information to get closer to get closer to set
          schedule.
        </p>
      </div>
      <div className="main-content">
        <div className="input-i-field input-attch-field">
          <div className="input-upload-file-wrapper">
            <div className="input-upload-file">
              <input
                type="file"
                id="FileUpload"
                name="file[files]"
                accept="image/x-png,image/jpeg"
                onChange={(event) => {
                  if (event.target.files && event.target.files[0]) {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                      props.handleState("ImageFile", event.target.files[0]);
                      props.handleState("userImage", e.target.result);
                    };
                    reader.readAsDataURL(event.target.files[0]);
                  }
                }}
              />
              <div className="upload-text-btn">
                Drag and drop files here or{" "}
                <a href="javascript:void(0)" className="btn btn-next">
                  Browse
                </a>
                <span className="upload_file_name"></span>
                <input
                  type="hidden"
                  name="upload_result"
                  tabIndex="0"
                  accept="image/x-png,image/gif,image/jpeg"
                  onChange={(event) => {
                    if (event.target.files && event.target.files[0]) {
                      let reader = new FileReader();
                      reader.onload = (e) => {
                        props.handleState("ImageFile", event.target.files[0]);
                        props.handleState("userImage", e.target.result);
                      };
                      reader.readAsDataURL(event.target.files[0]);
                    }
                  }}
                />
              </div>
            </div>
            <div className="uplode-preview">
              {userImage !== "" && <img src={userImage} alt="Page Banner" />}
            </div>
          </div>
        </div>
        <div className="input-text">
          <div className="input-div">
            <input
              type="text"
              id="user_name"
              placeholder="First Name*"
              name="first_name"
              value={FirstName}
              onChange={(e) => handleChange(e, "FirstName")}
              className={`${error && FirstName == "" ? "input-error" : ""}`}
            />
            <span class="not_placeholder">
              First Name <b>*</b>
            </span>
            {/* {error && FirstName == "" && <span className={'error-text'}>{"Please enter first name"}</span>} */}
          </div>
          <div className="input-div">
            <input
              type="text"
              placeholder="Last Name*"
              value={LastName}
              onChange={(e) => handleChange(e, "LastName")}
              className={`${error && LastName == "" ? "input-error" : ""}`}
            />
            <span class="not_placeholder">
              Last Name <b>*</b>
            </span>
            {/* {error && LastName == "" && <span className={'error-text'}>{"Please enter last name"}</span>} */}
          </div>
        </div>
        <div className="input-text">
          <div className="input-div">
            <input
              type="text"
              placeholder="E-mail Address*"
              name="email"
              value={Email}
              onChange={(e) => handleChange(e, "Email")}
              className={`${
                (error && Email == "") ||
                (error &&
                  !Email.match(
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  ))
                  ? "input-error"
                  : ""
              }`}
            />
            {/* {error && <span className={'error-text'}>{Email == "" ? "Please enter email" : !Email.match(
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) && "Please enter valid email"}</span>} */}
            <span class="not_placeholder">
              E-mail Address <b>*</b>
            </span>
          </div>
          <div className="input-div">
            <input
              type="text"
              placeholder="Phone number*"
              name="MobileNo"
              value={MobileNo}
              onChange={(e) => onHandleTelephoneChange(e, "MobileNo")}
              className={`${
                error && (MobileNo === "" || !ValidateMobile(MobileNo))
                  ? "input-error"
                  : ""
              }`}
            />
            <span class="not_placeholder">Phone number</span>
            {/* {error && MobileNo == "" && <span className={'error-text'}>{"Please enter mobile no"}</span>} */}
          </div>
        </div>
        <div className="input-text">
          <div className="input-div">
            <input
              type="text"
              ref={dateRef}
              max={moment(new Date()).format("YYYY-MM-DD")}
              placeholder="Birthdate*"
              name="BirthDate"
              value={BirthDate}
              onChange={(e) => handleChange(e, "BirthDate")}
              className={`${error && BirthDate == "" ? "input-error" : ""}`}
              onFocus={() => (dateRef.current.type = "date")}
              onBlur={() => (dateRef.current.type = "text")}
            />
            <span class="not_placeholder">
              Birthdate <b>*</b>
            </span>
          </div>
          {/* <div className="input-div">
                        <input type="text" placeholder="Age*" name="age" maxLength={3} value={Age} onChange={(e) => onHandleTelephoneChange(e, "Age")}
                            className={`${error && Age == "" ? 'input-error' : ''}`}
                        />
                       
                    </div> */}
        </div>
        <div className="input-text blood_branch">
          <div className="input-text gender_text">
            <div className="input-div-">
              <input
                id="r1"
                type="radio"
                name="Gender"
                defaultValue="Male"
                defaultChecked={Gender.toUpperCase() == "MALE"}
                onClick={() => {
                  props.handleState("Gender", "Male");
                }}
              />
              <label htmlFor="r1">Male</label>
            </div>
            <div className="input-div-">
              <input
                id="r2"
                type="radio"
                name="Gender"
                defaultValue="Female"
                defaultChecked={Gender.toUpperCase() == "FEMALE"}
                onClick={() => {
                  props.handleState("Gender", "Female");
                }}
              />
              <label htmlFor="r2">Female</label>
            </div>

            {/* {error && Gender == "" && <span className={'error-text'}>{"Please provid your gender"}</span>} */}
          </div>
          <div className="input-div">
            <ul>
              <li className="dropdown blod_group">
                {/* {<span class="not_placeholder">Select blood group <b>*</b></span>} */}
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    props.handleState("Options", {
                      show: !Options.show,
                      value: Options.value,
                    });
                    //setOptions((prev) => ({ ...prev, show: !Options.show }))
                  }}
                  data-toggle="dropdown"
                >
                  {Options.value == "" ? (
                    <span class="not_placeholder">Select blood group </span>
                  ) : (
                    Options.value
                  )}{" "}
                  <i
                    className={`icon-arrow fas fa-plus ${
                      Options.show ? "open" : "close"
                    }`}
                  ></i>
                </a>
                <ul
                  className={`dropdown-menu ${Options.show ? "show" : "hide"}`}
                >
                  {bloodType.map((item) => {
                    return (
                      <li key={item}>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            props.handleState("Options", {
                              show: !Options.show,
                              value: item,
                            });

                            //setOptions((prev) => ({ show: !Options.show, value: item }))
                          }}
                        >
                          {item}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div className="input-text blood_branch">
          {/* <div className="input-div">
                        <ul>
                            <li className="dropdown blod_group">
                                <a href="javascript:void(0)" onClick={() => {
                                    props.handleState("Options", { show: !Options.show, value: Options.value })
                                    //setOptions((prev) => ({ ...prev, show: !Options.show }))
                                }
                                } data-toggle="dropdown">{Options.value == "" ? 'Select blood group' : Options.value} <i className={`icon-arrow fas fa-plus ${Options.show ? 'open' : 'close'}`} ></i></a>
                                <ul className={`dropdown-menu ${Options.show ? 'show' : 'hide'}`}>
                                    {bloodType.map((item) => {
                                        return (<li key={item}><a href="javascript:void(0)" onClick={() => {
                                            props.handleState("Options", { show: !Options.show, value: item })

                                            //setOptions((prev) => ({ show: !Options.show, value: item }))
                                        }
                                        }
                                        >{item}</a></li>)
                                    })}

                                </ul>
                            </li>
                        </ul>
                    </div> */}
          {/* <div className="input-div">
                        <ul>
                            <li className="dropdown blod_group">
                                <a href="javascript:void(0)" onClick={() => {
                                    props.handleState("branchOption", { show: !branchOption.show, value: branchOption.value })
                                    //setOptions((prev) => ({ ...prev, show: !Options.show }))
                                }
                                } data-toggle="dropdown">{branchOption.value == "" ? 'Select blood group' : branchOption.value} <i className={`icon-arrow fas fa-plus ${branchOption.show ? 'open' : 'close'}`} ></i></a>
                                <ul className={`dropdown-menu ${branchOption.show ? 'show' : 'hide'}`}>
                                    {Branch.map((item) => {
                                        return (<li key={item}><a href="javascript:void(0)" onClick={() => {
                                            props.handleState("branchOption", { show: !branchOption.show, value: item })

                                            //setOptions((prev) => ({ show: !Options.show, value: item }))
                                        }
                                        }
                                        >{item}</a></li>)
                                    })}

                                </ul>
                            </li>
                        </ul>
                    </div> */}
        </div>

        <div className="input-text">
          <textarea
            placeholder="Address*"
            id="text-message"
            name="text-message"
            value={Address}
            onChange={(e) => handleChange(e, "Address")}
            className={`textarea-input ${
              error && Address == "" ? "input-error" : ""
            }`}
          />
          <span class="not_placeholder">
            Address <b>*</b>
          </span>
        </div>
        <div className="input-text">
          <textarea
            placeholder="Description"
            className="textarea-input"
            id="text-message"
            name="text-message"
            value={Description}
            onChange={(e) => handleChange(e, "Description")}
          />
          <span class="not_placeholder">Description</span>
        </div>
      </div>
      {/* <div className="buttons">
                <button className={`btn next_button ${isLoading?'btn--loading':''}`}  disabled={isLoading} onClick={(e) => { handleSubmit(e) }}>Next</button>
            </div> */}
      <div className="buttons">
        <button
          className={`btn next_button btn-relative ${
            isLoading ? "btn--loading" : ""
          }`}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          <span className="btn-text">Next</span>
          <span className="btn__loader">
            <div
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              className="progress-circular progress-circular--visible progress-circular--indet"
              style={{ height: 23, width: 23 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                style={{ transform: "rotate(0deg)" }}
              >
                <circle
                  fill="transparent"
                  cx="43.80952380952381"
                  cy="43.80952380952381"
                  r={20}
                  strokeWidth="3.8095238095238093"
                  strokeDasharray="125.664"
                  strokeDashoffset="125.66370614359172px"
                  className="progress-circular__overlay"
                />
              </svg>
            </div>
          </span>
        </button>
      </div>
    </div>
  );
}

export default PersonalInformation;
